import { render, staticRenderFns } from "./MailProcessingTemplateUpdate.vue?vue&type=template&id=09d2e34d"
import script from "./MailProcessingTemplateUpdate.vue?vue&type=script&lang=js"
export * from "./MailProcessingTemplateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports